<ng-container *ngIf="users">
  <span *ngFor="let user of users; index as i" class="user-blob color-{{i % 4}}" title="{{user.first}} {{user.last}} <{{user.email}}>">
    {{user.first[0].toUpperCase()}}{{user.last[0].toUpperCase()}}
  </span>
  <span *ngIf="overflow > 0" class="user-blob overflow">
    +{{overflow}}
  </span>
</ng-container>
